
import 'fslightbox';
import InView from './components/in-view.js';
import Swiper from './components/swiper.js';
import MenuButton from './components/menu-button.js';
import MiscJs from './components/misc.js';
import Scroll from './components/scroll.js';
import Form from './components/form.js';
import Modal from './components/modal.js';


window.addEventListener('load', function() {
    InView();
    Scroll();
    Form();
    MenuButton();
    MiscJs();
    Swiper();
    Modal();
})
